import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TvAction, TvModel } from "src/store";
import { Player as PlayerFunctions, PlayerService } from "src/services";
import { PlayerTvProps } from "./player.tv.props";

export const PlayerTv: React.FC<PlayerTvProps> = ({
    demoDuration, timeShift, message,
    thumbnail, trafficUsed, type, url, vastUrl
}) => {

    const videoRef = useRef<HTMLVideoElement>(null);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const player = useRef<PlayerFunctions | null>(null);
    const dispatch = useDispatch();

    const conductor: TvModel = useSelector((state: any) => state.TvState);


    useEffect(() => {

        const initPlayer = async () => {

            if (videoRef && videoRef.current) {

                const onPlay = () => {
                    if (conductor.currentChannel) dispatch(TvAction.startReporting(conductor.currentChannel.id, conductor.episode?.id));
                };

                const onPause = () => {
                    dispatch(TvAction.stopReporting());
                };

                if (player.current) {
                    player.current.changeStream(url, type, vastUrl, thumbnail, undefined, onPlay, onPause);
                }
                else {
                    player.current = await PlayerService.makePlayer();

                    player.current.initPlayer(videoRef.current, url, type, thumbnail, vastUrl, [], undefined, onPlay, onPause);
                }

            }

        };
        initPlayer();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, vastUrl]);


    useEffect(() => {
        return () => {
            //no need to call stopReporting, but better safe than sorry
            const onDispose = () => dispatch(TvAction.stopReporting());
            if (player.current) player.current.disposePlayer(onDispose);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div ref={wrapperRef} className="video-js-box vjs-player fkplayer vjs-player-wrapper">
            <div data-vjs-player>
                <video poster={thumbnail} ref={videoRef} className="video-js" playsInline></video>
            </div>
        </div>
    );
};
